<template>
  <div class="filters" :class="mainClass">
    <ShopsFilter ref="shops" class="filters__shops"></ShopsFilter>
    <div class="filters__row">
      <Sort
        class="filters__column filters__column--sort"
        :class="sortClass()"
      ></Sort>
      <RangePrice
        v-show="showRange()"
        class="filters__column filters__column--range"
      ></RangePrice>
      <RangePlaceholder v-if="!showRange()" />
      <div class="filters__column filters__column--buttons">
        <button
          @click="reset()"
          class="btn outline small filters__button filters__button--reset"
          v-t="'FL7'"
          :class="resetClass()"
        ></button>
        <button
          @click="submit()"
          class="btn primary small filters__button filters__button--submit"
          v-t="'FL8'"
          :class="submitClass()"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
import ShopsFilter from "./ShopsFilter.vue";
import Sort from "@/components/pages/products/Sort";
import RangePrice from "@/components/pages/products/RangePrice";
import { mapGetters } from "vuex";
import RangePlaceholder from "@/components/common/preloaders/RangePlaceholder";

export default {
  name: "Filters",
  components: { RangePlaceholder, RangePrice, Sort, ShopsFilter },
  props: {
    opened: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters("products", [
      "getResetButtonDisable",
      "getPrice",
      "getWasFiltered",
      "getIsFetchedFilters"
    ]),
    mainClass() {
      return this.opened ? "" : "filters--closed";
    }
  },
  destroyed() {
    this.$store.dispatch("products/removeStores");
  },
  methods: {
    submitClass() {
      return { unclickable: !this.getIsFetchedFilters };
    },
    sortClass() {
      return { unclickable: !this.getIsFetchedFilters };
    },
    resetClass() {
      return this.getResetButtonDisable && !this.getWasFiltered
        ? "disabled"
        : "";
    },
    showRange() {
      return !(
        this.getPrice &&
        this.getPrice.min === -1 &&
        this.getPrice.max === -1
      );
    },
    async reset() {
      if (this.getResetButtonDisable && !this.getWasFiltered) {
        return;
      }
      await this.$store.dispatch("products/filtersReset");
      if (this.getWasFiltered) {
        await this.$store.dispatch("products/filtersSubmit");
        await this.$store.dispatch("products/setWasFiltered", false);
      }
      this.$refs.shops.up();
    },
    async submit() {
      if (!this.getWasFiltered && this.getResetButtonDisable) {
        return;
      }
      await this.$store.dispatch("products/filtersSubmit");
      this.$refs.shops.up();
    }
  }
};
</script>

<style scoped lang="scss">
.filters {
  position: relative;
  margin-bottom: 40px;
  max-height: 226px;
  /*max-height: 0;*/
  transition: margin 0.3s ease-in-out, max-height 0.3s ease-in-out,
    z-index 0.3s linear 0.3s;
  overflow: visible;
  z-index: 11;
  &--closed {
    max-height: 0;
    margin: 0;
    overflow: hidden;
    z-index: -3;
  }
  &__shops {
    margin-bottom: 15px;
  }
  &__row {
    position: relative;
    display: flex;
  }
  &__column {
    --col: 1;
    width: calc(172px * var(--col) + 24px * (var(--col) - 1));
    margin-right: 20px;
    &--sort {
    }
    &--range {
      --col: 2;
    }
    &--buttons {
      position: relative;
      --col: 2;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin: 0;
      left: 1px;
    }
  }
  &__button {
    position: relative;
    width: 173px;
    &--reset {
      height: 30px;
    }
    &--submit {
      left: -1px;
    }
  }
}

.unclickable {
  user-select: none;
  pointer-events: none;
}
</style>
